import { createAsyncThunk } from "@reduxjs/toolkit";
import { client as axios } from "../../Utils/axiosClient";

export const getRentalList = createAsyncThunk(
  "rentals/getRentalList",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/rentals/get-rentals-list`,
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRentalRequest = createAsyncThunk(
  "rentals/getRentalRequest",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/rentals/get-rental-requests`,
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRentalsForTrikeV3 = createAsyncThunk(
  "rentals/getRentalsForTrikeV3",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/rentals/rentals-for-trike`,
        {
          params,
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);
